<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import moment from 'moment';

export default {
    page: {
        title: "Bookings",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: { Layout, PageHeader },

    data() {
		const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");
        return {
            title: "Bookings",
            items: [
                {
                    text: "Labs",
                    href: "/labs",
                },  
                {
                    text: "Bookings",
                    active: true,
                },        
            ],
            lab_bookings: [],
            keyword: "",
            type: "",
            listing_length: 10,
            cancel_consultation: {
                id: "",
            },
			now: datetime_now,

        }
    },
    mounted() {},
    created() {
        this.fetchBookings();
    },
    methods: {
        fetchBookings(page_url = null) {
            this.getToken();
            let url = "api/admin/lab/booking/index?lab_id=" + this.$route.params.id + "&limit=" + this.listing_length + "&status=" + this.type + "&keyword=" + this.keyword;
            page_url = page_url || url;

            if(localStorage.back_url) {
                page_url = localStorage.back_url;
                localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            this.$axios
                .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    // Use responseData.lab and responseData.bookings_count
                    this.lab_bookings = responseData.bookings.data;
                    this.from = responseData.bookings.from;
                    this.to = responseData.bookings.to;
                    this.total = responseData.bookings.total;
                    this.pagination = responseData.bookings.links;
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if (typeof error.response.data.message === 'object') {
                                console.log(error.response.status);
                            } else {
                                this.$swal("", error.response.data.message, "error");
                            }
                        }
                        else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
        },
        markComplete(lab_booking) {
			this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to mark this booking as complete?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
            this.getToken();
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };
            let url = "api/admin/lab/booking/complete";
            let formData = new FormData();
            formData.append("booking_id", lab_booking.id);
            this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.$router.push({ name: 'labs.bookings' });
                    this.fetchBookings();
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
                this.fetchBooking();
			}
            })
            .catch(err => {
               console.log(err);
            })
        },
        markNoShow(lab_booking) {
			this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to mark this booking as No show?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
            this.getToken();
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };
            let url = "api/admin/lab/booking/noShow";
            let formData = new FormData();
            formData.append("booking_id", lab_booking.id);
            this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.$router.push({ name: 'labs.bookings' });
                    this.fetchBookings();
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
                this.fetchBooking();
			}
            })
            .catch(err => {
               console.log(err);
            })
        },
		cancelBooking(booking_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to mark this booking as Cancel?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/lab/booking/cancel?booking_id=" + booking_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchBookings(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
         getToken() {
         if (localStorage.getItem('sigohealth_admin')) {
            var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
            if(sigohealth_admin.token) {
               this.token = sigohealth_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
        formatBookingDate(dateString) {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        },
        formatTime(time) {
            const formattedTime = new Date(`2002-02-02 ${time}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            return formattedTime;
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            return `${day} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
        },
		isBookingPast(lab_booking) {
            const consultationEndTime = moment(lab_booking.booking_date + ' ' + lab_booking.start_time);
            return consultationEndTime.isAfter(this.now);
           
         },
    },
}
</script>


<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">

					<!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'labs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
						
					<!----- Listing length and search starts ----->
					<div class="row mb-3">
						<div class="col-sm-12 col-md-6">
							<div class="listing-length" >
								<label
								>Show
								<select class="form-control" v-model="listing_length" @change = "fetchBookings()">
									<option value="5">5</option>
									<option value="10">10</option>
									<option value="15">15</option>
								</select>
								entries
								</label>
							</div>                        
						</div>
						<div class="col-sm-12 col-md-6">
							<div class="listing-filter">
								<label>
									<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup = "fetchBookings()"/>
								</label>
							</div>                     
							<div class="listing-filter me-2">
								<label>
								<select class="form-control" v-model="type" @change = "fetchBookings()">
									<option value="">All</option>
                                    <option value="1">Pending</option>
                                    <option value="2">No Show</option>
                                    <option value="3">Todays bookings</option>
                                    <option value="4">Completed</option>
								</select>
								</label>
							</div>   
						</div>
					</div>
					<!----- Listing length and search ends ----->
	
					<!---- listing table starts -------->
					<div class="table-responsive">
						<table class="table table-bordered mb-0">
	
							<thead class="table-light">
								<tr>
							<th>User</th>
							<th>Booked for</th>              
                           <th>Contact</th>
                           <!-- <th>Test name</th>         -->
                           <th>Booking Date</th>
                           <th>Type</th>
                           <th>Status</th>
                           <th>Created On</th>
                           <th>Options</th>
								</tr>
							</thead>
							<tbody v-if="Boolean(lab_bookings.length)">
								<tr v-for="lab_booking in lab_bookings" :key="lab_booking.lab_booking_id">
									<td> {{lab_booking.patient_name}} </td>
									<td>  <span v-if="lab_booking.member_id">{{ lab_booking.member_name }}</span>
										<span v-else>Self</span></td>
									<td>
										<span v-if="lab_booking.address">{{lab_booking.address.name}} <br>{{lab_booking.address.phone}} <br> {{lab_booking.address.email}}</span>
									</td>
									<!-- <td>{{lab_booking.test_name}}</td> -->
									<td>{{ formatBookingDate(lab_booking.booking_date) }}<br> {{ formatTime(lab_booking.start_time) }} - {{ formatTime(lab_booking.end_time) }}</td>
									<td> <span v-if="lab_booking.collecting_type === 1">
										Lab
										</span>
										<span v-else-if="lab_booking.collecting_type === 2">
										Home
										</span>
										
									</td>
									
									

									<!-- Booking Status -->
									<td>
                                        <p class="badge bg-success" v-if="lab_booking.status==1">Completed</p>
                                        <p class="badge bg-warning"  v-if="lab_booking.status==2">Pending</p>
                                        <p  v-if="lab_booking.status==3" class="badge bg-info">No Show<br></p>
                                        <p class="badge bg-danger" v-if="lab_booking.status==4">Cancelled</p>
									</td>
									
									
									<td>{{ lab_booking.converted_created_at }}</td>
									<td>
										<router-link :to="{ name: 'labs.bookings.details', params: { id: lab_booking.id }}" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>
										
										<b-button v-if="lab_booking.status === 2" @click="markComplete(lab_booking)"  class="btn btn-success me-2 mb-2 btn-sm">Mark As Complete</b-button>

										<b-button  v-if="lab_booking.status === 2" @click="markNoShow(lab_booking)"  class="btn btn-info me-2 mb-2 btn-sm">Mark As No Show</b-button>

										<b-button  v-if="lab_booking.status === 2  && isBookingPast(lab_booking)" @click="cancelBooking(lab_booking.id)"  class="btn btn-danger me-2 mb-2 btn-sm">Cancel</b-button>

									</td>
								</tr>

								
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="5" class="text-center">No bookings found</td>
								</tr>
							</tbody>

						</table>
					</div>
					<!---- listing table ends -------->
	
					<!----pagination starts ---> 
					<caption v-if="Boolean(lab_bookings.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
					<ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
						<li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
							<a href="#" class="page-link" @click.prevent="fetchBookings(page.url + '&lab_id='+ $route.params.id + '&limit='+ listing_length + '&status=' + type + '&keyword=' + keyword)">
							<i v-if="index == 0" class="mdi mdi-chevron-left"></i>
							<i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
							<span v-else>{{page.label}}</span>                          
							</a>
						</li>
					</ul>
					<!----pagination ends --->   
					<b-modal ref="cancel-modal" id="cancel-modal" title="Cancel Consultation" hide-footer>
                     <b-form @submit.prevent="cancelConsultation()" >
                        
                        <b-col md="12" class="form-group">
                           <label class="control-label">Reason for Cancellation</label>
                           <textarea class="form-control" rows="4" v-model="cancel_consultation.reason"></textarea>
                        </b-col>                      
                        
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary" @click="hideModal('cancel-modal')">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('cancel-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>           
	
					</div>
				</div>
			</div>

		</div>
	</Layout>
</template>
